/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult2,
  NotFoundErrorResult2,
  ResultOfListOfClientInvestmentDetailsViewModel,
  ResultOfListOfIntermediaryClientRelationshipViewModel,
  ValidationErrorResult2,
} from '../models';
import {
    ErrorResult2FromJSON,
    ErrorResult2ToJSON,
    NotFoundErrorResult2FromJSON,
    NotFoundErrorResult2ToJSON,
    ResultOfListOfClientInvestmentDetailsViewModelFromJSON,
    ResultOfListOfClientInvestmentDetailsViewModelToJSON,
    ResultOfListOfIntermediaryClientRelationshipViewModelFromJSON,
    ResultOfListOfIntermediaryClientRelationshipViewModelToJSON,
    ValidationErrorResult2FromJSON,
    ValidationErrorResult2ToJSON,
} from '../models';

export interface ReportingGetClientInvestmentDetailsRequest {
    clientId?: number;
}

/**
 * 
 */
export class ReportingApi extends runtime.BaseAPI {

    /**
     * Get a client\'s investment details.
     */
    async reportingGetClientInvestmentDetailsRaw(requestParameters: ReportingGetClientInvestmentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfClientInvestmentDetailsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v1/reporting/investment-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfClientInvestmentDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get a client\'s investment details.
     */
    async reportingGetClientInvestmentDetails(requestParameters: ReportingGetClientInvestmentDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfClientInvestmentDetailsViewModel> {
        const response = await this.reportingGetClientInvestmentDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Proposal and client
     */
    async reportingGetClientPlansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfIntermediaryClientRelationshipViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v1/reporting/plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfIntermediaryClientRelationshipViewModelFromJSON(jsonValue));
    }

    /**
     * Get Proposal and client
     */
    async reportingGetClientPlans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfIntermediaryClientRelationshipViewModel> {
        const response = await this.reportingGetClientPlansRaw(initOverrides);
        return await response.value();
    }

}
